import { useMutationWithToast } from '@pesto/ui';
import { Button, Typography } from '@pesto/ui';
import { useState } from 'react';

import type { ModalProps } from '../../types/modal.types';

import { useInitializeTwispForUser } from '../../../__generated__/rest/api';

export const UserTwispTimeManagement = (props: ModalProps<{ userId: string }>) => {
  const { payload, api } = props;
  const { userId } = payload;
  const [error, setError] = useState<string | null>(null);

  const initializeTwispForUserMutation = useInitializeTwispForUser();

  const { handleMutation } = useMutationWithToast();

  const handleInitializeTwisp = async () => {
    setError(null);
    await handleMutation({
      mutation: () =>
        initializeTwispForUserMutation.mutateAsync({
          data: {
            userId,
          },
        }),
      extractSuccess: (result) => !!result?.success,
      onSuccess: () => {
        api.close();
      },
      onError: (error) => setError(error.message),
      debugLabel: 'initialize-twisp-for-user',
      toast: {
        success: 'Twisp initialized successfully for user',
        error: 'Failed to initialize Twisp for user',
        loading: 'Initializing Twisp for user...',
      },
    });
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <Typography variant="body" className="font-medium">
          Initialize User in Twisp
        </Typography>
        <Typography variant="bodySmall" className="text-muted-foreground">
          Initialize Twisp ledger account for this user (dev/test environments only)
        </Typography>
        <Button
          onClick={() => void handleInitializeTwisp()}
          loading={initializeTwispForUserMutation.isPending}
          disabled={initializeTwispForUserMutation.isPending}
          variant="primary"
        >
          Initialize Twisp for User
        </Button>
      </div>

      {error && (
        <div className="text-danger bg-danger/10 rounded p-2">
          <Typography variant="bodySmall">{error}</Typography>
        </div>
      )}
    </div>
  );
};
